import { sortTypes } from '../data'


type Input = {
  skip: number
  limit: number
  search: string
  sort: VaultsPage.Sort
  address?: string | null
  filter: VaultsPage.Filter
}

const orderByNames = {
  [sortTypes.apy]: 'avgRewardPerAsset',
  [sortTypes.performance]: 'score',
  [sortTypes.tvl]: 'totalAssets',
} as const

const getRequestVariables = (values: Input) => {
  const { sort, limit, skip, filter, address, search } = values

  const whereParams = {} as SubgraphGraph.Vault_Filter

  if (filter === 'deposits' && address) {
    whereParams.or = [
      // @ts-ignore
      { allocators_: { address } } as SubgraphGraph.Vault_Filter,
      { exitRequests_: { owner: address } } as SubgraphGraph.Vault_Filter,
    ]
  }

  if (filter === 'all' && search) {
    whereParams.or = [
      { tokenName_contains_nocase: search } as SubgraphGraph.Vault_Filter,
      { tokenSymbol_contains_nocase: search } as SubgraphGraph.Vault_Filter,
      { displayName_contains_nocase: search } as SubgraphGraph.Vault_Filter,
      { description_contains_nocase: search } as SubgraphGraph.Vault_Filter,
      { addressString_contains_nocase: search } as SubgraphGraph.Vault_Filter,
    ]
  }

  return {
    orderBy: orderByNames[sort],
    where: whereParams,
    first: limit,
    skip,
  }
}


export default getRequestVariables
